/**
 * Date normalization utilities
 */

import { excelDateToJSDate } from '../../dateUtils';

/**
 * Verifica se uma string representa uma data válida
 * @param {string} dateString - String da data para validar
 * @returns {boolean} true se a data for válida, false caso contrário
 */
export function isValidDateString(dateString) {
  if (!dateString || typeof dateString !== 'string') return false;
  
  // Remove espaços extras
  const cleanDate = dateString.trim();
  if (!cleanDate) return false;
  
  // Verifica formato dd/mm/aaaa
  const brazilianDatePattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
  const match = cleanDate.match(brazilianDatePattern);
  
  if (match) {
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);
    
    // Verifica se os valores são válidos
    if (month < 1 || month > 12) return false;
    if (day < 1 || day > 31) return false;
    if (year < 1900 || year > 3000) return false;
    
    // Cria data e verifica se é válida
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && 
           date.getMonth() === month - 1 && 
           date.getDate() === day;
  }
  
  // Tenta outros formatos suportados pelo Date.parse
  const date = new Date(cleanDate);
  return !isNaN(date.getTime());
}

/**
 * Normalizes a single date field, handling both Excel date numbers and date strings
 * @param {number|string} dateValue - Date value to normalize
 * @returns {Date} Normalized Date object
 */
export function normalizeDate(dateValue) {
  if (typeof dateValue === 'number') {
    return excelDateToJSDate(dateValue);
  } else {
    return new Date(dateValue);
  }
}

/**
 * Normalizes date fields for lead time (committed and closed dates)
 * @param {Object} item - Item with date fields
 * @returns {Object} Object with commitedDate and closedDate as Date objects
 */
export function normalizeLeadTimeDates(item) {
  const commitedDate = normalizeDate(item['Committed Date']);
  const closedDate = normalizeDate(item['Closed Date']);
  return { commitedDate, closedDate };
}

/**
 * Normalizes date fields for throughput (only closed date)
 * @param {Object} item - Item with date fields
 * @returns {Object} Object with closedDate as Date object
 */
export function normalizeThroughputDates(item) {
  const closedDate = normalizeDate(item['Closed Date']);
  return { closedDate };
}
